"use strict";

var Marionette = require("marionette");
var Backbone = require("backbone");
var App = require("app");
var _ = require("lodash");

var View = require("./view.js");
var siUnitTables = require("src/common/app-constants").siUnits;

var rhmRegisters = require("src/common/app-constants-rhm").rhmRegister;
var rhmTypes = require("src/common/app-constants-rhm").types;
var rhmPermissionTypes = require("src/common/app-constants-rhm").permission_types;
var rhmPermissions = require("src/common/app-constants-rhm").permissions;

// keep track of the selected tab
var selectedTab
var activateTabTimeout
// -- TabsDefinition
// set which sensors should be shown on which page
var tabsDefinitions = [
  {
    registerId: 0,
    label:'Bedrijfssituatie',
    tables: [{
      id: 1,
      label: "Bedrijfs status",
      registers: [100, 101, 102, 103, 104, 1802, 105, 106, 107, 108, 110, 109, 113, 114, 115]
    },
    {
      id: 2,
      label: "Meetwaarden",
      registers: [200, 201, 202, 203, 205, 204, 206, 207, 208, 210]
    },
    {
      id: 3,
      label: "Bedrijfstijd",
      registers: [800, 801, 803, 802, 804, 805, 806]
    }]
  },
  {
    registerId: 1,
    label: 'Instellingen Tapwater',
    tables: [{
      id: 1,
      label: "Warmtapwater",
      registers: [300, 301, 302]
    },
    {
      id: 2,
      label: "Thermische desinfectie warmtewisselaar",
      registers: [400, 401, 402, 403]
    }]
  },
  {
    registerId: 10,
    label: "TE-Booster",
    tables: [{
      id: 1,
      label: "X",
      registers: [1800, 1804, 1805, 1812, 1813, 1815, 1816]
    }]
  },
  {
    registerId: 2,
    label: "Instellingen Verwarmen-Koelen",
    tables: [{
      id: 1,
      label: "Verwarming",
      registers: [500, 506, 507, 510, 509]
    },
    {
      id: 2,
      label: "Koeling",
      registers: [600, 606, 601, 602, 605]
    },
    {
      id: 3,
      label: "Secundair algemeen",
      registers: [512, 513, 603, 604]
    }]
  },
  {
    registerId: 11,
    label: "WKW Change Over",
    tables: [{
      id: 1,
      label: "Y",
      registers: [1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1863, 1864, 1866]
    }]
  },
  {
    registerId: 3,
    label: "Handbediening",
    tables: [{
      id: 1,
      label: "Handbediening",
      registers: [700, 701, 702, 703, 704, 1801, 709]
    }]
  },
  {
    registerId: 4,
    label: "Live log",
    tables: [{
      id: 1,
      label: "Tapwater",
      registers: [101, 107, 200, 201, 202, 203, 1007, 1008]
    },
    {
      id: 2,
      label: "CV",
      registers: [100, 108, 202, 203, 205, 204, 206, 113, 210, 1007, 1008]
    },
    {
      id: 3,
      label: "Koelen",
      registers: [104, 108, 110, 202, 203, 205, 600, 206]
    }]
  },
{
    registerId: 5,
    label: "M-Bus Info",
    tables: [{
      id: 1,
      label: "Meter 1",
      registers: [1000, 1001, 1002, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014]
    },
    {
      id: 2,
      label: "Meter 2",
      registers: [1050, 1051, 1052, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064]
    },
    {
      id: 3,
      label: "Meter 3",
      registers: [1100, 1101, 1102, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114]
    },
    {
      id: 4,
      label: "Meter 4",
      registers: [1150, 1151, 1152, 1156, 1157, 1158, 1159, 1160, 1161, 1162, 1163, 1164]
    }]
  },
  /*{
    registerId: 6,
    label: "Pre-payment",
    tables: [{
      id: 1,
      label: "Pre-payment",
      registers: [1400, 1401, 1403, 1404, 1405]
    }]
  },*/
  {
    registerId: 7,
    label: "M-Bus begrenzing",
    tables: [{
      id: 1,
      label: "Begrenzing",
      registers: [1500, 1501, 1503, 1504, 1505, 1506, 1507]
    }]
  },
  /*{
    registerId: 8,
    label: "Droogstook protocol",
    tables: [{
      id: 1,
      label: "Droogstook protocol",
      registers: [1700, 1701, 1702, 1703, 1704, 1705, 1706, 1708, 1709]
    }]
  },*/
  {
    registerId: 9,
    label: "Mbus meters",
    tables: [{
      id: 1,
      label: "Meter 1",
      registers: [1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218, 1219]
    },
    {
      id: 2,
      label: "Meter 2",
      registers: [1220, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239]
    },
    {
      id: 3,
      label: "Meter 3",
      registers: [1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1259]
    },
    {
      id: 4,
      label: "Meter 4",
      registers: [1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279]
    },
    {
      id: 5,
      label: "Meter 5",
      registers: [1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299]
    }]
  },
  {
    registerId: 12,
    label: "Storings Geschiedenis",
    tables: [{
      id: 1,
      label: "Geschiedenis lock out errors",
      registers: [820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834]
    },
    {
      id: 2,
      label: "Geschiedenis Block errors",
      registers: [860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874]
    }]
  }
  ]



// -----
var DeviceShow = function(options) {
  var Controller = Marionette.Object.extend({
    initialize: function(options) {
      var self = this;

      this.region = options.region;
      this.device = options.device;
      this.formules = {
        voltage: function(value) {
          return value;
        },
        temp: function(value) {
          return (value - 1000) * 0.1;
        },
        lux: function(value) {
          return value;
        },
        energy_power: function(value) {
          return value;
        },
        active_power: function(value) {
          return value * 10;
        },
        mbus_power: function(value) {
          return value / 1000;
        },
        temp_reg: function(value) {
          value = parseInt(value, 0);
          if ((value & 0x8000) > 0) {
            value -= 0x10000;
          }
          return value / 10;
        },
        float: function (value) {
          var data =  [((value >> 24) & 0xFF), ((value >> 16) & 0xFF), ((value >> 8) & 0xFF), (value & 0xFF)];

          var buf = new ArrayBuffer(4);
          var view = new DataView(buf);

          data.forEach(function (b, i) {
            view.setUint8(i, b);
          });

          return view.getFloat32(0).toPrecision(5);
        }
      };

      this.sensorDef = {
        pri_voltage: {
          label: "Primary Voltage AC",
          min: 0,
          target: 380000,
          max: 500000,
          unit: "VAC",
          digits: 0,
          formule: "voltage",
          autoRange: true,
          units: siUnitTables.voltage
        },
        sec_voltage: {
          label: "Secondary Voltage DC",
          min: 0,
          target: 380000,
          max: 500000,
          unit: "VDC",
          digits: 0,
          formule: "voltage",
          autoRange: true,
          units: siUnitTables.voltage
        },
        pri_current: {
          label: "Primary Current",
          min: 0,
          max: 16000,
          unit: "mA",
          digits: 0,
          autoRange: true,
          units: siUnitTables.current
        },
        sec_current: {
          label: "Secondary Current",
          min: 0,
          max: 16000,
          unit: "mA",
          digits: 0,
          autoRange: true,
          units: siUnitTables.current
        },
        stm_temperature: {
          label: "Stm Temperature",
          min: -100,
          target: "",
          max: 200,
          unit: "&deg;C",
          formule: "temp",
          digits: 0
        },
        rfm_temperature: {
          label: "Rfm Temperature",
          min: -100,
          target: "",
          max: 200,
          unit: "&deg;C",
          formule: "temp",
          digits: 0
        },
        ext_temperature: {
          label: "Ext Temperature",
          min: -100,
          target: "",
          max: 200,
          unit: "&deg;C",
          formule: "temp",
          digits: 0
        },
        lux: {
          label: "Lux",
          min: 0,
          target: "",
          max: 1000,
          unit: "lux",
          formule: "lux",
          digits: 0
        },
        co2: {
          label: "Co2",
          min: 0,
          target: "",
          max: 2000,
          unit: "ppm",
          digits: 0,
          autoRange: true,
          units: siUnitTables.parts
        },
        wh: {
          label: "Energy Usage",
          min: 0,
          max: 50,
          unit: "Wh",
          digits: 0,
          units: siUnitTables.energy
        },
        power: {
          label: "Active Power",
          min: 0,
          max: 1000,
          unit: "W",
          digits: 0,
          autoRange: true,
          formule: "active_power",
          units: siUnitTables.power
        },
        reactive_power: {
          label: "Reactive Power",
          min: 0,
          max: 1000,
          unit: "W",
          digits: 0,
          autoRange: true,
          formule: "active_power",
          units: siUnitTables.power
        },
        apparent_power: {
          label: "Apparent Power",
          min: 0,
          max: 1000,
          unit: "W",
          digits: 0,
          autoRange: true,
          formule: "active_power",
          units: siUnitTables.power
        },
        power_factor: {
          label: "Power factor",
          digits: 0,
          autoRange: true,
          formule: "active_power",
        },
        energy: {
          label: "Active Energy Import",
          min: 0,
          max: 1000,
          unit: "kW",
          digits: 0,
          autoRange: true,
          units: siUnitTables.power,
          formule: "float",
          valueDigits: 3
        },
        active_energy_export: {
          label: "Active Energy Export",
          min: 0,
          max: 1000,
          unit: "kW",
          digits: 0,
          autoRange: true,
          units: siUnitTables.power,
          formule: "float",
          valueDigits: 3
        },
        reactive_energy_import: {
          label: "Reactive Energy Import",
          min: 0,
          max: 1000,
          unit: "kW",
          digits: 0,
          autoRange: true,
          units: siUnitTables.power,
          formule: "float",
          valueDigits: 3
        },
        reactive_energy_export: {
          label: "Reactive Energy Export",
          min: 0,
          max: 1000,
          unit: "kW",
          digits: 0,
          autoRange: true,
          units: siUnitTables.power,
          formule: "float",
          valueDigits: 3
        },
        frequency: {
          label: "Frequency",
          min: 0,
          max: 100,
          unit: "Hz",
          digits: 0,
          autoRange: true,
          units: siUnitTables.frequency
        },
        particle_mass_10: {
          label: "Particle mass 10pm",
          min: 0,
          max: 60,
          unit: "µg/m3",
          formule: "float",
          valueDigits: 3,
        },
        particle_mass_25: {
          label: "Particle mass 25pm",
          min: 0,
          max: 60,
          unit: "µg/m3",
          formule: "float",
          valueDigits: 3,
        },
        particle_mass_40: {
          label: "Particle mass 40pm",
          min: 0,
          max: 60,
          unit: "µg/m3",
          formule: "float",
          valueDigits: 3,
        },
        particle_mass_100: {
          label: "Particle mass 100pm",
          min: 0,
          max: 60,
          unit: "µg/m3",
          formule: "float",
          valueDigits: 3,
        },
        particle_nr_05: {
          label: "Particle nr 05pm",
          min: 0,
          max: 300,
          unit: "#/cm3",
          formule: "float",
          valueDigits: 3,
        },
        particle_nr_10: {
          label: "Particle nr 10pm",
          min: 0,
          max: 300,
          unit: "#/cm3",
          formule: "float",
          valueDigits: 3,
        },
        particle_nr_25: {
          label: "Particle nr 25pm",
          min: 0,
          max: 300,
          unit: "#/cm3",
          formule: "float",
          valueDigits: 3,
        },
        particle_nr_40: {
          label: "Particle nr 40pm",
          min: 0,
          max: 300,
          unit: "#/cm3",
          formule: "float",
          valueDigits: 3,
        },
        particle_nr_100: {
          label: "Particle nr 100pm",
          min: 0,
          max: 300,
          unit: "#/cm3",
          formule: "float",
          valueDigits: 3,
        },
        particle_size: {
          label: "Particle size",
          min: 0,
          max: 100,
          unit: "µm",
          digits: 1,
          formule: "float",
          valueDigits: 3,
        }
      };

      this.layout = self.getLayoutView(this.device);

      self.listenTo(self.layout, "render", () => {
        self.sensorsRegion();
        self.statusRegion();

        // show tabs when this is an rtm_rhm device
        if (self.device.get('type') === 'rtm_rhm' || self.device.get('type') === 'rtm_rhm_mqtt') {
          self.tabsRegion(selectedTab);
          if (selectedTab) {
            self.activateTab(selectedTab, self)
          }
        }

      });

      //
      self.listenTo(self.layout, "childview:error:reset", () => {
        self.device.resetErrorState();
      });

      // perform a modbus register fetch
      self.listenTo(self.layout, "control:fetch", function() {
        // get current tab id
        let activeTabModel = self.tabsCollection.find(function(model) {
          return model.get('active') === true; }
        );
        // get the register id
        let registerId = activeTabModel.get('registerId');
        // construct the package
        let command = {command:'modbus_registers.get.register', value:registerId}
        //  send te command
        let device = self.device
         device.sendCommand(command, {
           success:(value) => {
             App.dialog.notice(App.TextParser('NOTICE_COMMAND_SENT'))
           }
         })
      });

      this.region.show(this.layout);
    },
    populateSensorCollection: function(tab) {
      var self = this;

      // empty the sensor collection, this is necessary to make
      // the tabs work, and refresh the sensors layout
      if (tab !== undefined) {
        self.sensorCollection.reset()
      }

      var sensorOrder = [
        "pri_voltage",
        "sec_voltage",
        "pri_current",
        "sec_current",
        "particle_mass_10",
        "particle_mass_25",
        "particle_mass_40",
        "particle_mass_100",
        "particle_nr_05",
        "particle_nr_10",
        "particle_nr_25",
        "particle_nr_40",
        "particle_nr_100",
      ];

      // remove sensors which are used in the sideview only or are ignored completely
      var sensors = _.omit(self.device.get("sensors"), [
        "modbus_registers",
        "vibration",
        "novoferm",
        "voltage_detect",
        "tilt",
        "tilt_detect",
        "current_detect",
        "tamper_detect",
        "parking_detect",
        "tamper",
        "signal_quality_rssi",
        "signal_quality_ber",
        "radar",
        "nfc",
        "power_factor"
      ]);

      // modbus registers
      var registers = _.pick(self.device.get("sensors"), ["modbus_registers"]);
      /* add mapping array (ext_temp_group register addresses and label name) */

      _.forEach(sensors, function(sensor, sensorName) {
        if (!sensor.enabled) {
          self.sensorCollection.remove(sensorName);
          return;
        }

        var value = sensor.value;

        // var value = 130000
        var sortIndex = sensorOrder.indexOf(sensorName);
        if (sortIndex < 0) sortIndex = 100;

        var sensorDef = self.sensorDef[sensorName];

        if (sensorDef) {
          if (sensorDef.formule) {
            value = self.formules[sensorDef.formule](value);
          }
        }

        if (!self.sensorCollection.get(sensorName)) {
          var sensorModel = {
            id: sensorName,
            type: "gauge",
            value: value,
            def: sensorDef || {},
            position: sortIndex
          };
          self.sensorCollection.add(sensorModel);
        }
        var sensorModel = self.sensorCollection.get(sensorName);

        sensorModel.set("value", value);
      });


      // if a device has modbus register
      if (registers.modbus_registers) {

        tab = (tab) ? tab : 0;
        let tableDefinitions = tabsDefinitions.find(obj => obj.registerId == tab)['tables'];

        for (var tableDefIndex = 0; tableDefIndex < tableDefinitions.length; tableDefIndex++) {
          let tableDefinition = tableDefinitions[tableDefIndex];
          let values = [];
          tableDefinition.skip = [];

          /*
        { label: "Heat Outlet",         id: 4  },

        { label: "Cool Outlet",         id: 10 },
        { label: "Cool Inlet",          id: 11 },
        { label: "Heat Inlet",          id: 12 },
        { label: "Cooling / Heating",   id: 13 },

        */

          if (tab == 5 || tab == 9) { // mbus tabs
            if (!(_.get(registers, "modbus_registers.value." + tableDefinition.registers[0])) &&
              !(_.get(registers, "modbus_registers.value." + tableDefinition.registers[1]))) { // skip table if there is no mbus attached
                continue;
            }
            if (tab == 9)
            {
              var medium = _.get(registers, "modbus_registers.value." + tableDefinition.registers[3]); // medium register

              // bi medium is the default
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[9]}).label = "Heating Energy";
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[9]}).type = 110;  // set energy to GJ
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[13]}).label = "Cooling Energy"
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[13]}).type = 110;  // set energy to GJ
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).label = "Fixed Heating Energy";
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).type = 110;
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[18]}).label = "Fixed Cooling Energy";
              _.find(rhmRegisters, {'regAddr': tableDefinition.registers[18]}).type = 110;

              if (medium)
              {
                let regs = tableDefinition.registers;
                if (medium == 10 || medium == 11 || medium == 4 || medium == 12) // heating / cooling
                {
                  // ignore energy 2 and fixed register 2
                  tableDefinition.skip.push((regs[13]), (regs[14]), (regs[18]), (regs[19]));
                  if (medium == 10 || medium == 11) {
                    _.find(rhmRegisters, {'regAddr': tableDefinition.registers[9]}).label = "Cooling Energy";
                    _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).label = "Fixed Cooling Energy";
                  }
                } else if (medium == 6 || medium == 7 || medium == 16 || medium == 17) { // water
                   // ignore power, return temperature, energy, energy 2 and fixed register 2
                   tableDefinition.skip.push((regs[6]), (regs[8]), (regs[9]), (regs[10]), (regs[13]), (regs[14]), (regs[18]), (regs[19]));
                  _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).type = 111;  // set to Volume
                  _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).label = "Fixed Volume"
                } else if (medium == 2) { // electricity
                  // ignore temperature's, flow, volume and fixed register 2
                  tableDefinition.skip.push((regs[5]), (regs[7]), (regs[8]), (regs[11]), (regs[12]), (regs[18]), (regs[19]));
                 _.find(rhmRegisters, {'regAddr': tableDefinition.registers[13]}).type = 112;  // set energy to mA
                 _.find(rhmRegisters, {'regAddr': tableDefinition.registers[13]}).label = "Current"
                 _.find(rhmRegisters, {'regAddr': tableDefinition.registers[9]}).type = 114;  // set energy to kWh
                 _.find(rhmRegisters, {'regAddr': tableDefinition.registers[9]}).label = "Energy"
                _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).type = 114; // set energy to kWh
                _.find(rhmRegisters, {'regAddr': tableDefinition.registers[15]}).label = "Fixed Energy"
                }
              }
            }
          }

          _.forEach(tableDefinition.registers, function(registerKey) {
            if (tableDefinition.skip.includes(registerKey)) return

            let rhmTypeDef = _.find(rhmRegisters, {'regAddr':registerKey});
            let value = _.get(registers, "modbus_registers.value." + registerKey);
            let unit = ''
            let editable = false;

            for (var i = 1; i < rhmTypeDef.size; i++) {
              if (tableDefinition.registers.indexOf(registerKey + i) != -1) {
                value = (value << 16) | _.get(registers, "modbus_registers.value." + (registerKey + i));
                tableDefinition.skip.push(registerKey + i);
              } else {
                break;
              }
            }

            // adjust value based on type of value
            switch (rhmTypeDef.type) {
              case rhmTypes.TEMP:
                value = (value != null) ? self.formules['temp_reg'](value) : "";
                unit = '&deg;C';
                break;
              case rhmTypes.PRES:
                value = (value != null) ? self.formules['temp_reg'](value) : "";
                unit = 'bar';
                break;
              case rhmTypes.ENERGY:
                value = (value != null) ? value / 1000 : "";
                unit = 'GJ';
                break;
              case rhmTypes.ENERGY_kWh:
                  unit = 'kWh';
                  value = (value != null) ? (value / 1000) : "";
                  break;
              case rhmTypes.POWER:
                value = (value != null) ? value / 100 : "";
                unit = 'kW';
                break;
              case rhmTypes.POWER_NORMAL:
                if (value != null)
                {
                  value = parseInt(value);
                  if ((value & 0x8000) > 0) {
                    value = value - 0x10000;
                  }
                }
                value = (value != null) ? value / 1000 : "";
                unit = 'kW';
                break;
              case rhmTypes.CURRENT:
                  unit = 'mA';
                  value = (value != null) ? value : "";
                  break;
              case rhmTypes.FLOW_L_H:
                value = (value != null) ? value / 10 : "";
                unit = 'L/h';
                break;
              case rhmTypes.FLOW_L_M:
                value = (value != null) ? value : "";
                unit = 'L/m';
                break;
              case rhmTypes.FLOW_DL_M:
                value = (value != null) ? value : "";
                unit = 'dL/m';
                break;
              case rhmTypes.FLOW_M3_H:
                value = (value != null) ? value : "";
                unit = 'm&sup3/H';
                break;
              case rhmTypes.STEPS:
                unit = 'steps';
                value = (value != null) ? value : "";
                break;
              case rhmTypes.TIME_S:
                value = (value != null) ? value : "";
                unit = 'sec';
                break;
              case rhmTypes.TIME_M:
                unit = 'min';
                value = (value != null) ? value : "";
                break;
              case rhmTypes.TIME_H:
                unit = 'uren';
                value = (value != null) ? value : "";
                break;
              case rhmTypes.TIME_D:
                  unit = 'dagen';
                  value = (value != null) ? value : "";
                  break;
              case rhmTypes.PERC:
                  unit = '%';
                  value = (value != null) ? value : "";
                  break;
              case rhmTypes.HEX:
                if (value != null) {
                  value = (value >>> 0);
                  value = value.toString(16);
                }
                break;

              case rhmTypes.VOLUME:
                unit = 'L';
                value = (value != null) ? value : "";
                break;
              case rhmTypes.VOLUME_M3:
                unit = 'm&sup3';
                value = (value != null) ? value : "";
                break;
              case rhmTypes.DATE:
                if (value != null)
                {
                  var a = new Date(value * 1000);
                  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                  var year = a.getFullYear();
                  var month = months[a.getMonth()];
                  var day = String(a.getDate()).padStart(2, "0");
                  var hour = String(a.getHours()).padStart(2, "0");
                  var min = String(a.getMinutes()).padStart(2, "0");
                  var sec = String(a.getSeconds()).padStart(2, "0");
                  value = day + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
                }
                break;

            }

            // check if the register is editable
            _.forEach(rhmPermissions, (permission_group) => {
              if (registerKey >= permission_group[0] && registerKey <= permission_group[1] && (rhmPermissionTypes.READ || rhmPermissionTypes.READ_WRITE)) {
                editable = true;
                return
              }
            })

            //
            values.push({
              key: registerKey,
              value: value,
              label: rhmTypeDef.label,
              type: rhmTypeDef.type,
              editable: editable,
              unit:unit
            });
          });

          // add the table to the list of sensors
          tableDefinition.values = values

          if (self.sensorCollection.get(tableDefinition.id)) {
            let sensorModel = self.sensorCollection.get(tableDefinition.id)
            sensorModel.set("value", values);
          } else {
            var sensorModel = {
              id: tableDefinition.id,
              type: "table",
              value: values,
              label: tableDefinition.label
            };
          }

          self.sensorCollection.add(sensorModel);

          //tables.push(tableDefinition)
        };
      }
      self.sensorCollection.sort();
    },
    /* Event methods --------------------------------------------------------- */
    onDestroy: function() {},
    /* Regions --------------------------------------------------------------- */
    statusRegion: function() {
      var self = this;
      self.statusLayout = self.getStatusView(self.device);
      self.layout.showChildView("statusRegion", self.statusLayout);
    },
    activateTab: function(inTab, context) {
      selectedTab = inTab

      // reset all tabs
      context.tabsCollection.each(function ( tab ) {
        if (!inTab) {
          tab.set("active",false);
        } else {
          if (tab.get('id') == inTab.model.get('id')) {
            tab.set("active",true);
          } else {
            tab.set("active",false);
          }
        }
      }, this);

      // populate the tab with tab specific sensors
      context.populateSensorCollection(inTab.model.get('id'))
    },
    tabsRegion: function(activeTab) {
      var self = this;

      // setup the tabs
      var TabsModel = Backbone.Model.extend({});
      var TabsCollection = Backbone.Collection.extend({
        model: TabsModel
      });

      self.tabsCollection = new TabsCollection();

      // tabs
      tabsDefinitions.forEach((tab, key) => {
        let modelData = {
          id: tab.registerId,
          registerId: tab.registerId,
          label: tab.label
        }
        // active the first tab by default
        if (activeTab) {
          if (activeTab.model.get('id') == key) {
            modelData.active = true
          }
        } else if (key === 0) {
          modelData.active = true
        }

        self.tabsCollection.add(modelData)
      })

      // set the tabs
      self.tabsLayout = self.getTabsView(self.tabsCollection);
      self.layout.showChildView("tabsRegion", self.tabsLayout);

      // handle the selection of tabs
      self.tabsLayout.listenTo(self.tabsLayout, "childview:tab:select", function(tab) {
        self.activateTab(tab, self);
      });

      if (activeTab) {
        clearTimeout(activateTabTimeout);
        activateTabTimeout = setTimeout(() => {
          self.activateTab(activeTab, self);
        }, 0)


      }

      //
      // if (selectedTab) {
      //   selectedTab.set("active",true);

      //   self.populateSensorCollection(selectedTab.get('id'))

      // }

    },
    sensorsRegion: function() {
      var self = this;
      var SensorModel = Backbone.Model.extend({});
      var SensorCollection = Backbone.Collection.extend({
        model: SensorModel,
        comparator: function(model) {
          return model.get("position");
        }
      });

      self.sensorCollection = new SensorCollection();
      self.populateSensorCollection();
      self.sensorLayout = self.getSensorsView(self.sensorCollection);

      self.sensorLayout.listenTo(this.device, "change", function() {
        self.populateSensorCollection();
      });

      self.sensorLayout.listenTo(self.sensorLayout, "childview:register:set", function(register) {
        App.globalChannel.trigger('device:register', {region: App.rootLayout.getRegion('dialogRegion'), device: self.device, register:register})
      });

      self.layout.showChildView("sensorsRegion", self.sensorLayout);
    },
    /* Views ----------------------------------------------------------------- */
    getTabsView: function(tabs) {
      return new View.TabsView({ collection: tabs });
    },
    getStatusView: function(device) {
      return new View.StatusView({ model: device });
    },
    getSensorsView: function(sensors) {
      return new View.SensorsView({ collection: sensors });
    },
    getLayoutView: function(device) {
      return new View.Layout({ model: device });
    }
  });

  return new Controller(options);
};

module.exports = DeviceShow;



// WEBPACK FOOTER //
// ./js/modules/device-status/show/index.js